import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type {
  InternalLabelArea,
  LabelInspectionAreaType,
} from '@ulysses-inc/harami_api_client'
import { LabelInspectionAreaType as AreaType } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { DeleteConfirmButton } from '../DeleteConfirmButton'

/** リストで表現されているときは、省略して表示する */
const areaTypeLabel: Record<LabelInspectionAreaType, string> = {
  [AreaType.PATTERN]: '見た目',
  [AreaType.EXPIRATION]: '日付',
  [AreaType.ALPHANUMERIC]: '英数字',
  [AreaType.ALPHANUMERIC_INPUT]: '英数字',
  [AreaType.BARCODE]: 'バーコード',
} as const

type Props = {
  onClickArea: (area: InternalLabelArea) => void
  areas: InternalLabelArea[]
  deleteArea: (id: string) => void
}

export const AreaTable: FC<Props> = ({ areas, onClickArea, deleteArea }) => {
  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table sx={{ bgcolor: 'white', width: '100%' }}>
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                px: 2,
                py: 1,
                whiteSpace: 'nowrap',
              },
            }}
          >
            <TableCell>検査箇所名</TableCell>
            <TableCell>タイプ</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {areas.map(area => (
            <TableRow
              key={area.id}
              sx={{
                cursor: 'pointer',
                '&:hover': { backgroundColor: 'action.hover' },
                '& td': { py: 2 },
              }}
            >
              <TableCell onClick={() => onClickArea(area)}>
                {area.name}
              </TableCell>
              <TableCell onClick={() => onClickArea(area)}>
                {areaTypeLabel[area.type]}
              </TableCell>
              <TableCell>
                <DeleteConfirmButton
                  name="検査箇所"
                  onDelete={() => deleteArea(area.id)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
